var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 16",
    width: 18,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.71445146547012e-17, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.92,1.01c-0.2,-0.59 -0.76,-1.01 -1.42,-1.01h-11c-0.66,0 -1.21,0.42 -1.42,1.01l-1.97,5.67c-0.07,0.21 -0.11,0.43 -0.11,0.66v7.16c0,0.83 0.67,1.5 1.5,1.5c0.83,0 1.5,-0.67 1.5,-1.5v-0.5h12v0.5c0,0.82 0.67,1.5 1.5,1.5c0.82,0 1.5,-0.67 1.5,-1.5v-7.16c0,-0.22 -0.04,-0.45 -0.11,-0.66zM3.5,11c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5zM14.5,11c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5zM2,6l1.27,-3.82c0.14,-0.4 0.52,-0.68 0.95,-0.68h9.56c0.43,0 0.81,0.28 0.95,0.68l1.27,3.82z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 74, 93)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-163030958302312622",
    d: "M15.92,1.01c-0.2,-0.59 -0.76,-1.01 -1.42,-1.01h-11c-0.66,0 -1.21,0.42 -1.42,1.01l-1.97,5.67c-0.07,0.21 -0.11,0.43 -0.11,0.66v7.16c0,0.83 0.67,1.5 1.5,1.5c0.83,0 1.5,-0.67 1.5,-1.5v-0.5h12v0.5c0,0.82 0.67,1.5 1.5,1.5c0.82,0 1.5,-0.67 1.5,-1.5v-7.16c0,-0.22 -0.04,-0.45 -0.11,-0.66zM3.5,11c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5zM14.5,11c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5zM2,6l1.27,-3.82c0.14,-0.4 0.52,-0.68 0.95,-0.68h9.56c0.43,0 0.81,0.28 0.95,0.68l1.27,3.82z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/Vehicle.55b8c3e70a43f7adbcd86649acdd1a5a.svg";
export { ForwardRef as ReactComponent };